module.exports = __webpack_public_path__ + "img/puas.673d75c9.jpeg";